// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAAy8uXyfI0cXB_MwZRXo_NS5mJTgxME2Q",
  authDomain: "al-noor-edtech.firebaseapp.com",
  projectId: "al-noor-edtech",
  storageBucket: "al-noor-edtech.firebasestorage.app",
  messagingSenderId: "1044546709321",
  appId: "1:1044546709321:web:6f2a5aa38dd64ae9cf5c98",
  measurementId: "G-PL1EDN2R52"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app); // ✅ THIS is what you need
